import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiJson } from '../api/client.js';
import { useNotificationSocket } from '../context/NotificationSocketContext.jsx';

export function NotificationsBell() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const { subscribe } = useNotificationSocket();

  const load = useCallback(() => {
    apiJson('/api/notifications?unread_only=1')
      .then(setItems)
      .catch(() => setItems([]));
  }, []);

  useEffect(() => {
    load();
    const onInbox = () => load();
    window.addEventListener('staff-chat-inbox', onInbox);
    return () => window.removeEventListener('staff-chat-inbox', onInbox);
  }, [load]);

  useEffect(() => {
    return subscribe((notification) => {
      if (!notification?.id || notification.read_at) return;
      setItems((prev) => {
        if (prev.some((n) => n.id === notification.id)) return prev;
        return [notification, ...prev];
      });
      window.dispatchEvent(new CustomEvent('staff-task-refresh'));
    });
  }, [subscribe]);

  const markAll = async () => {
    await apiJson('/api/notifications/read-all', { method: 'POST' });
    setItems([]);
    setOpen(false);
  };

  const markOne = async (id) => {
    await apiJson(`/api/notifications/${id}/read`, { method: 'PUT' });
    load();
  };

  return (
    <div className="notif-bell">
      <button
        type="button"
        className="icon-btn"
        onClick={() => setOpen((o) => !o)}
        aria-label={items.length ? `Alerts, ${items.length} unread` : 'Alerts'}
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
          <path d="M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.2V11a6 6 0 1 0-12 0v3.2a2 2 0 0 1-.6 1.4L4 17h5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9.5 17a2.5 2.5 0 0 0 5 0" strokeLinecap="round" />
        </svg>
        {items.length ? <span className="icon-btn-badge">{items.length > 9 ? '9+' : items.length}</span> : null}
      </button>
      {open ? (
        <div className="notif-bell-panel">
          <div className="notif-bell-head">
            <strong>Alerts</strong>
            {items.length ? (
              <button type="button" className="btn-link" onClick={() => void markAll()}>
                Mark all read
              </button>
            ) : null}
          </div>
          {items.length === 0 ? (
            <p className="muted small" style={{ margin: 0 }}>
              No unread alerts
            </p>
          ) : (
            <ul className="list-plain" style={{ margin: 0, padding: 0 }}>
              {items.slice(0, 10).map((n) => (
                <li key={n.id} className="notif-bell-item">
                  <strong>{n.title}</strong>
                  {n.body ? <div className="muted small">{n.body}</div> : null}
                  <div className="row-actions" style={{ marginTop: 4 }}>
                    {n.link ? (
                      <Link to={n.link} className="btn-link" onClick={() => void markOne(n.id)}>
                        Open
                      </Link>
                    ) : null}
                    <button type="button" className="btn-link" onClick={() => void markOne(n.id)}>
                      Dismiss
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      ) : null}
    </div>
  );
}

/** @deprecated Use NotificationsBell */
export { NotificationsBell as StaffNotificationsBell };
